import React from 'react';
import FeeTypesEnum from '../../../Enums/FeeTypesEnum';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import FreelancerUserIgnoredSurveyData from '../../../Domain/FreelancerUserIgnoredSurveyData';
import FreelancerUserIgnoredSurveyService from '../../../Services/FreelancerUserIgnoredSurveyService';
import DataSourceEnum from '../../../Enums/DataSourceEnum';

export default class AddIgnoredSurveyWindowDescription extends React.Component {
  static titleForCreate = 'Add Ignored Survey';
  static itemType = FreelancerUserIgnoredSurveyData;
  static serviceFunction = (edited) => FreelancerUserIgnoredSurveyService.AddIgnoredSurvey(edited);
  static lastCiBtid = '';

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      hide: (item) => item.CiStatusCode === 3,
      fields: [
        {
          fieldName: 'FreelancerUserId',
          label: 'Vendor ID',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'FreelancerUserName',
          label: 'Vendor Name',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'FeeType',
          label: 'Fee Type',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: (editedItem) => AddIgnoredSurveyWindowDescription.GetFeeTypeValues(editedItem),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ClientId',
          label: 'Client',
          className: 'col-12',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'Source',
          label: 'Source',
          className: 'col-12',
          type: InputTypesEnum.SourceSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'SurveyId',
          label: 'Survey',
          className: 'col-12',
          type: InputTypesEnum.SurveySelect,
          hide: (item) => item.Source !== DataSourceEnum.Apollo,
          disabled: (item) => !item.ClientId,
          validityChecker: ValidityHelper.forRequiredSelectField,
          idFilter: 'ClientId',
          onFieldChange: AddIgnoredSurveyWindowDescription.onSurveyChange,
        },
        {
          fieldName: 'TpSurveyId',
          label: 'Third-Party Survey',
          className: 'col-12',
          type: InputTypesEnum.TpSurveySelect,
          hide: (item) => item.Source !== DataSourceEnum.ThirdParty,
          disabled: (item) => !item.ClientId,
          validityChecker: ValidityHelper.forRequiredSelectField,
          idFilter: 'ClientId',
          onFieldChange: AddIgnoredSurveyWindowDescription.onTpSurveyChange,
        },
      ],
    },
  ];

  static GetFeeTypeValues(editedItem) {
    const selectValues = [{ label: 'Choose one...', value: null, disabled: false }];

    if (editedItem.FreelancerUserIsRM)
      selectValues.push({ label: FeeTypesEnum.RM, value: FeeTypesEnum.RM, disabled: false });
    if (editedItem.FreelancerUserIsDQ)
      selectValues.push({ label: FeeTypesEnum.DQ, value: FeeTypesEnum.DQ, disabled: false });

    return selectValues;
  }

  static onSurveyChange(editedItem) {
    editedItem.TpSurveyId = null;
  }

  static onTpSurveyChange(editedItem) {
    editedItem.SurveyId = null;
  }
}
